module.exports = __webpack_public_path__ + "assets/img/03.747a2a73.png";